import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { getFloodRiskPanelDisplay } from '../../../utils/floodRiskDisplay';
import {
  LOT_INFO_FIELD_ROW_SX,
  LotInfoMetricIndicator,
  lotInfoFieldLabelLayoutSx,
  lotInfoFieldValueSx,
} from './formBlockUi';

const TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      textAlign: 'center',
      maxWidth: 280,
      whiteSpace: 'normal',
      fontSize: '12px',
      lineHeight: 1.4,
    },
  },
};

/**
 * Fila de zona inundable (`flood_risk_pct`). Se usa dentro de LotRiesgosSection.
 */
const LotZonaInundableSection = ({ floodRiskPct = null }) => {
  const display = getFloodRiskPanelDisplay(floodRiskPct);

  return (
    <Box sx={LOT_INFO_FIELD_ROW_SX}>
      <Typography sx={lotInfoFieldLabelLayoutSx()}>
        Riesgo de inundación
      </Typography>

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: '7px',
        }}
      >
        <Tooltip
          title={display.tooltip}
          placement="top"
          arrow
          slotProps={TOOLTIP_SLOT_PROPS}
        >
          <Box
            component="span"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '7px',
              maxWidth: '100%',
              cursor: 'help',
            }}
          >
            <LotInfoMetricIndicator color={display.accentColor} />
            {display.level && (
              <Typography component="span" sx={lotInfoFieldValueSx({ muted: true })}>
                {display.level}
              </Typography>
            )}
            <Typography
              component="span"
              sx={lotInfoFieldValueSx({ monospace: true })}
            >
              {display.pctLabel}
            </Typography>
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default LotZonaInundableSection;
